import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button } from "../Object";
import { Link } from "react-router-dom";

const Contact = (props) => {
  const gridProps = {
    button: {
      size: 'fit-content',
      layout: ['repeat(2, 320px)', '100%'],
      dir: ['column', 'row'],
      gap: ['80px', '48px'],
    }
  }

  return (
    <>
      <Space size={['0 0 130px', '0 0 80px']}>
        <div className="p-contact__wrap">
          <Texts
            class="c-text--en c-text--bold c-text--center c-text--main p-contact__text--title"
            slug="contact/title"
          ></Texts>
          <Space size={["72px 0 64px", "56px 0 48px"]}>
            <Texts slug="contact/body" class="c-text--center c-text--med"></Texts>
          </Space>
          <Space size={['0 auto', '0 auto']}>
            <Grid {...gridProps.button}>
              <ContactButton slug="number"></ContactButton>
              <ContactButton slug="form"></ContactButton>
            </Grid>
          </Space>
        </div>
      </Space>
    </>
  );
};

export const ContactButton = (props) => {
  const gridProps = {
    top: {
      gap: "16px",
      layout: "100%",
      dir: "row",
      size: "100%",
    },
  };
  let innerClass = {
    number: 'c-text--en c-text--bold',
    form: 'c-text--bold'
  }
  const link = {
    number: 'tel: 0789874877',
    form: '/contact/'
  }
  return (
    <>
      <Grid {...gridProps.top}>
        <Texts class="c-text--center c-text--med" slug={`contact/top-${props.slug}`}></Texts>
        <object>
          <Button link={link[props.slug]} innerClass={innerClass[props.slug]} slug={`${props.slug}`} type="contact-number"></Button>
        </object>
        <Texts class="c-text--center c-text--med" slug={`contact/bottom-${props.slug}`}></Texts>
      </Grid>
    </>
  );
};

export default Contact;
